import { render, staticRenderFns } from "./LoadplanColumns.vue?vue&type=template&id=40ccda51"
import script from "./LoadplanColumns.vue?vue&type=script&lang=ts"
export * from "./LoadplanColumns.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports